import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useWorkspaceInvalidate } from '@/hooks/api/0101_workspace';
import { useEffect } from 'react';
import { toastApiError, toastSuccess } from '@/lib/toast';
import { useDestroyBoardSetting } from '@/hooks/api/2490_destroy_board_setting';
import { Link } from 'react-router-dom';
import { ModalConfirm } from '@/components/element/modal/ModalConfirm';

export const BoardElement = () => {
  const { setShowLoading } = useLoading();
  const { _w_, me } = useCurrentWorkspace();
  const { mutate, isPending, isSuccess, error } = useDestroyBoardSetting();
  const { invalidate: invalidateWorkspace } = useWorkspaceInvalidate(_w_!.identifier);

  useEffect(() => {
    if (isSuccess) {
      invalidateWorkspace();
      toastSuccess('board連携を解除しました');
    }
  }, [isSuccess]);

  useEffect(() => setShowLoading(isPending), [isPending]);
  useEffect(() => toastApiError(error), [error]);

  const disconnect = () => {
    mutate({ identifier: _w_!.identifier });
  };

  // MF連携済みの場合は非表示
  if (_w_!.money_forward_setting) return null;

  return (
    <div className="card mb-4" id="basic-info">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-8">
          <h5 className="mb-0">board連携</h5>
        </div>
        <div className="col-md-4 d-flex justify-content-end">
          {me!.admin && _w_!.board_setting == null && (
            <Link to={`/w/${_w_!.identifier}/setting/connect/board/new`} className="btn bg-gradient-primary btn-icon">
              <i className="fas fa-plus-circle"></i>新規連携
            </Link>
          )}
          {me!.admin && _w_!.board_setting && (
            <Link
              to={`/w/${_w_!.identifier}/setting/connect/board/new`}
              className="btn bg-gradient-danger btn-icon"
              data-bs-toggle="modal"
              data-bs-target={`#boardDisconnectConfirm`}
            >
              <i className="fas fa-minus-circle"></i>連携解除
            </Link>
          )}
        </div>

        <ModalConfirm
          modalId={'boardDisconnectConfirm'}
          okClicked={disconnect}
          message={'連携を解除します。よろしいですか？'}
        />
      </div>
      <div className="card-body pt-0">
        <div className="form-group">
          <label>接続ステータス</label>
          <p className="form-text text-muted text-sm ms-1">{_w_!.board_setting ? '連携済み' : '未連携'}</p>
        </div>
      </div>
    </div>
  );
};
